import styled from "styled-components"
import {device} from "../../styles/variables";

export const ContainerCatalogSt = styled.div`
  @media ${device.laptop} {
    padding: 0 60px;
  }
`;
